import ReactVisibilitySensor from "react-visibility-sensor"
import BorderLeftBox from "../../components/boxes/BorderLeftBox"
import governancePageData from "../../data/english/subpages/governance-page-data"
import MainHeader from "../../layouts/MainHeader"
import Separator from "../../components/Separator"
import SecondaryCard from "../../components/cards/SecondaryCard"
import DarkSection from "../../components/sections/ColoredSection/DarkSection"
import FlexViewOne from "../../components/FlexView/FlexViewOne"
import GalleryCard from "../../components/cards/GalleryCard"
import Footer from "../../layouts/Footer"
import TitleBorderLeft from "../../components/Text/TitleBorderLeft"
import TablePrimary from "../../components/Table/TablePrimary"
import CardSection from "../../components/sections/CardSection/CardSection"
import LindedList from "../../components/Lists/LindedList"
import ScrollView from "../../components/ScrollView/ScrollView"
import CardThree from "../../components/cards/CardThree"
import TitleSection from "../../components/sections/TitleSection"

const GovernancePage = () => {
    return (
        <main id="main" className="page">
            <div className="sticky-view-two">
                <div className="sticky-container">
                    <MainHeader
                        image={{
                            src: require('../../assets/images/wallpaper/governence.jpg'),
                            alt: "Governance Header Wallpaper",
                        }}
                        title=""
                    />
                </div>
                <div className="sticky-container-two" id="mainContent">
                    <div className="wrapper-small">
                        <h1 className="title-center">{governancePageData.mainTitle}</h1>
                        <div className="space-50"></div>
                        <BorderLeftBox
                            title={governancePageData.borderSection.title}
                            subtitle={governancePageData.borderSection.subtitle}
                        />
                        <p className={`text-paragraph`}>
                            {governancePageData.paragraphOne}
                        </p>

                        <p className={`text-paragraph`}>
                            {governancePageData.paragraphTwo}
                        </p>
                        <p className={`text-paragraph`}>
                            {governancePageData.paragraphThree}
                        </p>
                    </div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    {/* <Separator /> */}
                    <TitleSection title={governancePageData.sectionOne.title} />
                    {
                        governancePageData.sectionOne.cards.map((item, index) => (
                            <SecondaryCard
                                key={index}
                                title={item.title}
                                subtitle={item.subtitle}
                                icon={{
                                    name: require(`../../assets/icons/governance/${item.icon}`),
                                    alt: "",
                                }}
                            />
                        ))
                    }
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="wrapper-small">
                        <h2 className="text-title">{governancePageData.sectionTwo.title}</h2>
                        <TitleBorderLeft>{governancePageData.sectionTwo.tableOne.title}</TitleBorderLeft>
                        <TablePrimary
                            headers={governancePageData.sectionTwo.tableOne.table.headers}
                            textDirection={["s", "e", "e", "e"]}
                        >
                            {
                                governancePageData.sectionTwo.tableOne.table.data.map((item, index) => (
                                    <tr>
                                        <td>{item.element}</td>
                                        <td className="td-e">{item[2020]}</td>
                                        <td className="td-e">{item[2021]}</td>
                                        <td className="td-e">{item[2022]}</td>
                                    </tr>
                                ))
                            }
                        </TablePrimary>
                        <p className="text-paragraph">{governancePageData.sectionTwo.tableOne.paragraph}</p>
                    </div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="wrapper-small">
                        <TitleBorderLeft>{governancePageData.sectionTwo.tableTwo.title}</TitleBorderLeft>
                        <p className="text-paragraph">{governancePageData.sectionTwo.tableTwo.paragraph}</p>
                        <TablePrimary
                            head={governancePageData.sectionTwo.tableTwo.table.head}
                            headers={governancePageData.sectionTwo.tableTwo.table.headers}
                        >
                            {governancePageData.sectionTwo.tableTwo.table.data.map((item, index) => (
                                <tr key={index}>
                                    {item.map((itemTwo, indexTwo) => (
                                        <td key={index * indexTwo}>{itemTwo}</td>
                                    ))}
                                </tr>
                            ))}
                        </TablePrimary>
                    </div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <CardSection
                        title={governancePageData.sectionThree.title}
                        subtitle={governancePageData.sectionThree.subtitle}
                        image={{
                            src: require(`../../assets/images/sections/${governancePageData.sectionThree.image.name}`),
                            alt: governancePageData.sectionThree.image.alt,
                        }}
                    />
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="space-50"></div>
                    <div className="wrapper-small">
                        <h2 className="title-center">{governancePageData.sectionFour.title}</h2>
                        <p className="text-paragraph">{governancePageData.sectionFour.paragraph}</p>
                        <BorderLeftBox
                            title={governancePageData.sectionFour.borderBox.title}
                            subtitle={governancePageData.sectionFour.borderBox.subtitle}
                        />
                        <div className="space-50"></div>
                        <LindedList list={governancePageData.sectionFour.linedData} />
                        <div className="space-50"></div>
                        <ScrollView>
                            {governancePageData.sectionFour.cardsOne.map((item, index) => (
                                <CardThree
                                    key={index}
                                    title={item.title}
                                    subtitle={item.subtitle}
                                    list={item.list}
                                />
                            ))}
                        </ScrollView>

                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <img src={require('../../assets/images/sections/esg-governance-structure.png')} className="tab-wallpaper-image"></img>
                        <BorderLeftBox
                            title={governancePageData.sectionFour.borderBoxThree.title}
                            subtitle={governancePageData.sectionFour.borderBoxThree.subtitle}
                        />
                        <img src={require('../../assets/images/sections/sustainable-finance-government.png')} className="tab-wallpaper-image"></img>
                        <BorderLeftBox
                            title={governancePageData.sectionFour.borderBoxTwo.title}
                            subtitle={governancePageData.sectionFour.borderBoxTwo.subtitle}
                        />
                        <ul className="normal-list">
                            {governancePageData.sectionFour.listOne.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                        <p className="text-paragraph">
                            {governancePageData.sectionFour.paragraphTwo}
                        </p>
                        <ScrollView>
                            {governancePageData.sectionFour.cardsTwo.map((item, index) => (
                                <CardThree
                                    key={index}
                                    title={item.title}
                                    subtitle={item.subtitle}
                                />
                            ))}
                        </ScrollView>
                        <div className="space-50"></div>
                        <p className="text-paragraph">{governancePageData.sectionFour.paragraphThree}</p>
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                    </div>
                    {/* <DarkSection>
                    <div className="wrapper-small">
                        <FlexViewOne>
                            {
                            governancePageData.flexViewSection.map((item, index) => (
                                <div className="flex-view-one-col" key={index}>
                                    <GalleryCard
                                        key={index}
                                        title={item.title}
                                        subtitle={item.subtitle}
                                        image={{
                                            src : require(`../../assets/images/cards/${item.image.name}`),
                                            alt : item.image.alt
                                        }}
                                        button={item.button}
                                    />
                                </div>
                            ))
                            }
                        </FlexViewOne>
                    </div>
                </DarkSection> */}
                    <Footer withBlogs={false} />
                </div>

            </div>
        </main>
    )
}

export default GovernancePage